import * as React from 'react';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/pro-light-svg-icons';

type CheckboxIconProps = {
  selected: boolean;
} & Omit<FontAwesomeIconProps, 'icon'>;

export const CheckboxIcon: React.FC<CheckboxIconProps> = ({
  selected,
  ...rest
}) => <FontAwesomeIcon icon={selected ? faSquareCheck : faSquare} {...rest} />;
